const siteTypes = ['LOAD_SITES', 'SELECT_SITE'];

export default siteTypes;
